import { omdApi } from '../api';

const request = omdApi.injectEndpoints({
  endpoints: (builder) => ({
    testSignalR: builder.mutation<void, void>({
      query: (data) => ({
        url: '/v1/SignalR',
        method: 'POST',
        body: data,
      }),
    }),
  }),
});

export const { useTestSignalRMutation } = request;
